<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2" style="text-align: start">
                <strong>{{ $t('costCenters') }}</strong>
              </CCol>
              <CCol col="8" style="text-align: start">
              </CCol>


              <CCol col="2" style="text-align: end">
                <CButton v-if="status_form ==0" class="mr-1 ml-1" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" class="mr-1 ml-1" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="3">
                <CInput
                        :label="$t('costCenterName')"
                        v-model="name"
                        autocomplete="name"
                />
              </CCol>
              <CCol col="3">
                <CRow>
                  <label>{{$t('components.totalAccount')}}</label>
                  <treeselect
                          v-model="selected_filter_child_add"
                          :options="all_accounting_items.filter(x=>x.parentId==8)"
                          :normalizer="normalizer_accounting"
                  />
                </CRow>

              </CCol>
              <CCol col="3">
                <CRow>
                  <label>{{$t('components.moenAccount')}}</label>
                  <treeselect
                          v-model="selected_filter_moein_add"
                          :options="all_accounting_items.filter(x=>x.parentId==selected_filter_child_add)"
                          :normalizer="normalizer_accounting"
                  />
                </CRow>

              </CCol>
              <CCol col="3">
                <CRow>
                  <label>{{$t('components.bankAccTitle')}}</label>
                  <treeselect
                          v-model="selected_filter_tafsili_add"
                          :options="tafsili_list"
                          :normalizer="normalizer_tafsili"
                  />
                </CRow>

              </CCol>
            </CRow>
          </CCardHeader>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('costCenterList') }}</strong>
          </CCardHeader>
          <CCardBody>
<!--            <CRow>-->


<!--              <CCol col="4">-->
<!--                <CRow form class="form-group">-->
<!--                  <CCol tag="label" sm="3" class="col-form-label">-->
<!--                    {{ $t('components.department') }}-->
<!--                  </CCol>-->
<!--                  <CCol sm="9">-->
<!--                    <treeselect-->
<!--                        v-model="selected_filter_parent"-->
<!--                        :options="items_natures"-->
<!--                        :normalizer="normalizer_filter_item"-->
<!--                    />-->
<!--                  </CCol>-->
<!--                </CRow>-->
<!--              </CCol>-->
<!--              <CCol col="4">-->
<!--                <CRow form class="form-group">-->
<!--                  <CCol tag="label" sm="3" class="col-form-label">-->
<!--                    {{ $t('units') }}-->
<!--                  </CCol>-->
<!--                  <CCol sm="8">-->
<!--                    <treeselect-->
<!--                        v-model="selected_filter_child"-->
<!--                        :options="items_child"-->
<!--                        :normalizer="normalizer_filter_item"-->
<!--                    />-->
<!--                  </CCol>-->

<!--                </CRow>-->
<!--              </CCol>-->
<!--              <CCol col="4">-->
<!--                <CRow form class="form-group">-->
<!--                  <CCol tag="label" sm="3" class="col-form-label">-->
<!--                    {{ $t('SomeUnit') }}-->
<!--                  </CCol>-->
<!--                  <CCol sm="8">-->
<!--                    <treeselect-->
<!--                        v-model="selected_filter_moein"-->
<!--                        :options="items_moein"-->
<!--                        :normalizer="normalizer_filter_item"-->
<!--                    />-->
<!--                  </CCol>-->
<!--                </CRow>-->
<!--              </CCol>-->


<!--            </CRow>-->
            <CDataTableFixed
                :items="data_filtered"
                :fields="fields_new"
                style="overflow: auto"
                :items-per-page="20"
                hover
                height="300px"
                border
                striped

                pagination
            >
              <template #access_name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>
              <template v-for="(group_item , index2) in items" v-slot:[get_group_name(index2)]="{item}">

                <td class="text-center">
                  <CIcon
                      @click.native="group_item.mainDepartemans.splice(group_item.mainDepartemans.indexOf(item.id),1)"
                      v-if="group_item.mainDepartemans.includes(item.id)" class="text-success" name="cil-check"/>
                  <CIcon @click.native="add_to_group_item(index2,item.id)" v-else name="cil-check"/>

                </td>
              </template>
              <template v-for="(group_item , index2) in items" v-slot:[get_group_header(index2)]>
                <CRow class="m-0 text-center">
                  <CImg src="/img/save_icon.jpeg" width="15px" height="15px" @click.native="edit_data(group_item)"/>
                  <CIcon addWrapperClasses="m-0 p-0" addInputClasses="m-0  p-0" @click.native="edit_item(group_item)"
                         class="p-0 m-0" size="sm" name="cil-pencil"/>
                  <CIcon addWrapperClasses="m-0  p-0" addInputClasses="m-0  p-0" v-c-tooltip="{
        content: $t('deleteCostCenter'),
        placement: 'bottom-start'
      }" @click.native="delete_item_dialog(group_item)" size="sm" class="p-0 m-0" name="cil-trash"/>

                  <CInput disabled addWrapperClasses="m-0" class="m-0" addInputClasses="text-center"
                          :value.sync="group_item.costCenterName"/>

                </CRow>
                <CRow class="m-0 text-center">
                </CRow>
              </template>
              <template #access_name-header="{item}">

                <div style="text-align: start">
                  <label >{{ $t('companyUnits') }}</label>

                </div>

              </template>

            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      data_accounting: [],
      selected_chart: null,
      data_with_children: [],
      items: [],
      items_new: [],
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'title', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'parentId', label: this.$t('departman'), _style: 'width:20%'},
        {key: 'operation', label: "", filter: false, _style: 'width:5%;'},
      ],
      fields_new: [],
      collapseDuration: 0,
      status_form: 0,
      items_natures: [],
      items_parent: [],
      selected_filter_parent: 0,
      items_child: [],
      items_child_add: [],
      selected_filter_child_add: null,
      selected_filter_moein_add: null,
      selected_filter_tafsili_add: null,
      tafsili_list: [],
      selected_filter_child: 0,
      selected_filter_moein: 0,
      items_moein: [],
      all_accounting_items: [],
      items_moein_add: [],
      data_filtered: [],
      normalizer_filter_item(node) {
        return {
          id: node.id,
          label: node.title,
          children: node.children,

        }
      },
      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode+" "+node.accountName,
          children: node.children,

        }
      }, normalizer_tafsili(node) {
        return {
          id: node.recId,
          label: node.tafsiliCode+" "+node.title,
          children: node.children,

        }
      },
    }
  },
  mounted() {
    this.$root.root_validate_errors = [];
    this.get_departments();
    this.get_lists();
    this.get_lists_groups();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_filter_parent': function () {
      this.selected_filter_child = 0;
      this.filter_data();
    },
    'selected_filter_child_add': function () {
      this.selected_filter_moein_add = null;
    },
    'selected_filter_moein_add': function () {
      this.select_moein()
    },
    'selected_filter_child': function () {
      this.filter_data();
      this.selected_filter_moein = 0;

      // var objects = this.get_parent(this.selected_filter_child).reverse();
      // this.selected_node_parents = ''
      // for (var i = 0; i < objects.length; i++) {
      //   this.selected_node_parents += " - " + objects[i]
      // }
    },
    'selected_filter_moein': function () {
      this.filter_data();

      // var objects = this.get_parent(this.selected_filter_moein).reverse();
      // this.selected_node_parents = ''
      // for (var i = 0; i < objects.length; i++) {
      //   this.selected_node_parents += " - " + objects[i]
      // }
    },
  },
  methods: {
    add_to_group_item(index,item_id){
      var exists=false;
      for (var i = 0; i < this.items.length; i++) {
        if(this.items[i].mainDepartemans.includes(item_id)){
          exists=true;
        }
      }
      if(!exists){
        this.items[index].mainDepartemans.push(item_id)

      }
    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

                var content_data = response.data;

                if (content_data.statusCode == 0) {
                  // self.items_receive = content_data.data.map((item, row_id) => {
                  //   return {...item, row_id}
                  //
                  // });

                  self.all_accounting_items = response.data.data
/////////////////////filter parent/////////////

                  /////////////////end fiter parent////////////////

                  // self.get_lists_moeins();

                } else {
                  self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                }
              }
      )
              .catch(function (error) {
                console.log(error);
              });

    },

    filter_data() {
      var self = this;
      this.items_child = []
      this.items_moein = []

      this.data_filtered = this.items_new.filter(x=>x.parentId==0);
      return ;
      var all_data_sub_4 = [];

      this.items_natures = this.items_new.filter(item2 => item2.parentId == 0)
      this.items_natures.splice(0, 0, {title: this.$t('all'), id: 0});
      if (this.selected_filter_parent != 0) {
        this.items_child = this.items_new.filter(item2 => item2.parentId == this.selected_filter_parent)
        this.items_child.splice(0, 0, {title: this.$t('all'), id: 0});
      }
      if (this.selected_filter_child != 0) {
        this.items_moein = this.items_new.filter(item2 => item2.parentId == this.selected_filter_child)
        this.items_moein.splice(0, 0, {title: this.$t('all'), id: 0});
      }
      if (self.selected_filter_parent == 0) {
        self.data_filtered = self.get_last_row(self.items_new);
        return false;
      } else {
        if (self.selected_filter_child == 0) {
          self.data_filtered = self.get_childrens_all_sub2(self.selected_filter_parent, self.items_new);
          return false;
        } else {

          if (self.selected_filter_moein == 0) {
            self.data_filtered = self.get_childrens_all_sub2(self.selected_filter_child, self.items_new);
            return false;
          } else {

            self.data_filtered = self.get_childrens_all_sub2(self.selected_filter_moein, self.items_new);
            return false;
          }
        }

      }

      this.data_filtered = all_data_sub_4;

    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      list.forEach((val2) => {
        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);
        }
      });
      return array;
    },
    get_last_row(list) {
      var return_list = [];
      list.forEach((val2) => {
        if (val2.parentId == 0) {

          var ret_list = this.get_childrens_all_sub_last(val2.id,this.items_new);
          return_list = return_list.concat(ret_list)
        }

      });
      return this.get_childrens_all_sub_last(0,this.items_new);;
    },
    get_childrens_all_sub(parent_id, list) {
      var self = this;
      var array = [];
      list.forEach((val2) => {
        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          var child_data = self.get_childrens_all_sub(val2.id, self.items_new);
          // if(child_data.length){

          // array.splice(0,0,child_data)
          // }
          array.push(val2);
          for (var i = 0; i < child_data.length; i++) {
            array.push(child_data[i]);
          }
        }
      });
      return array;
    },
    get_childrens_all_sub2(parent_id, list) {
      var self = this;
      var array = [];
      list.forEach((val2) => {
        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          var child_data = self.get_childrens_all_sub(val2.id, self.items_new);
          // if(child_data.length){

          // array.splice(0,0,child_data)
          // }
          if (self.get_childrens_one_sub(val2.id, self.items_new).length==0) {

            array.push(val2);
          }
          for (var i = 0; i < child_data.length; i++) {
            if (self.get_childrens_one_sub(child_data[i].id, self.items_new).length==0) {

              array.push(child_data[i]);
            }
          }
        }
      });
      return array;
    },
    get_childrens_all_sub_last(parent_id, list) {
      var self = this;
      var array = [];
      // console.log("parent id ",parent_id)

      self.get_childrens_all_sub(0, self.items_new).forEach((val2) => {
        // console.log("fisrt item ",val2)

        // if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          // var child_data = ;
          // if(child_data.length){
        // console.log("childs ",val2.id,child_data)

          // array.splice(0,0,child_data)
          // }
          //  array.push(val2);

          // for (var i = 0; i < child_data.length; i++) {
            if (self.get_childrens_one_sub(val2.id, self.items_new).length==0) {
              array.push(val2);
            }
          // }
        // }
      });
      return array;
    },
    edit_data(group_item) {
      let self = this;
      // this.edit_item(group_item);
      const formData = new FormData();
      let url;

      url = "AddCostCenterDeparteman";
      formData.append('CostCenterId', group_item.costCenterId)

      group_item.mainDepartemans.forEach((val) => {
        // OperationSystems.push({val});
        formData.append('MainDepartemans', val);

      });
      formData.append('groupName', group_item.groupName);
      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res)
        // self.status_form = 0;
        // self.name = '';
        // self.role_checkbox_items = [];
        // self.description = '';
        // self.previewImage = '';
        // self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_group_name(index) {
      return "group_" + index
    },
    get_group_header(index) {
      return "group_" + index + "-header"
    },
    get_parent(item) {
      return this.data_with_children.filter(item2 => item2.id == item.mainDepartemanId)[0].title
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.file != '' && this.description != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.file == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertImage'));
      }
      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      if (this.description == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      }
      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      this.name = item.costCenterName
      this.status_form = item.costCenterId
      this.selected_filter_child_add = this.all_accounting_items.filter(x=>x.id == item.accountId)[0].parentId
      setTimeout(() => {
        // this.result.push(event.type);
        this.selected_filter_moein_add = item.accountId
        this.selected_filter_tafsili_add = item.tafsiliId
      }, 500);


    },

    update_item() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)

      // this.addGroupModal = false;


      let self = this;
      const formData = new FormData();
      let url;

      url = "CostCenter/Update";
      formData.append('id',this.status_form)

      formData.append('MainDepartemanId', this.selected_chart);


      formData.append('title', item.costCenterName);
      // formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {
        //


        // self.$root.modal_component.show_api_response_modals(res);


        // self.get_lists();


      })

          .catch(function (error) {
            console.log(error);
          });


    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    get_departments() {
      var self = this;

      const formData = new FormData();

      formData.append('Id', 0);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.data_accounting = []


          self.data_with_children = response.data.data.filter(item2 => item2.recType == 0);

          self.items_new = self.data_with_children
          self.data_filtered = self.items_new
          self.filter_data()

          // if (self.selected_node == 0) {
          //       self.selected_node = self.data_accounting.children[0];
          //       // this.selected_node = node
          //     }
          // self.get_mate_accounts()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);

          // val2.inserted = true;

        }
        // if (parent_id == val2.parentId &&val2.recType == 1) {
        //   var obj2 = {
        //     name: val2.title,
        //     id: val2.id,
        //     children: this.get_childrens(val2.id, list),
        //     // mate: this.get_mates(val2.id, list),
        //     recType: val2.recType,
        //
        //     class:["my_mate"],
        //     parentId: val2.parentId,
        //     image_url: '/img/avatars/custom2.png',
        //
        //   }
        //   array.push(obj2);

        // val2.inserted = true;

        // }
      });
      if (array.length) {
        return array;

      } else {
        return null;

      }

    },

    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      formData.append('RecType', 1);


      axios.post('GetCostCenters', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.fields_new = [];
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.fields_new.push({key: 'access_name', label: self.$t('companyUnits'), _style: 'width:10%'})

          for (var i = 0; i < content_data.data.length; i++) {
            self.fields_new.push({key: 'group_' + i, label: content_data.data[i].costCenterName, _style: 'width:10%'})
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {


      // this.addGroupModal = false;


      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "CostCenter/Add";

      } else {
        url = "CostCenter/Update";
        formData.append('id', this.status_form)

      }
      formData.append('MainDepartemanId', this.selected_chart);


      formData.append('title', this.name);
      formData.append('AccountId', this.selected_filter_moein_add);
      // formData.append('TafsiliId', this.selected_filter_moein_add);
      formData.append('TafsiliId', this.selected_filter_tafsili_add);
      // formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      })

          .catch(function (error) {
            console.log(error);
          });

    },
    select_moein() {
      var self = this;

      const formData = new FormData();
      var url = "GetAccountTafsiliList";
      formData.append("id", this.selected_filter_moein_add);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

                var content_data = response.data;

                if (content_data.statusCode == 0) {

                  // item.tafzili_list = response.data.data;
                  self.tafsili_list = response.data.data
                } else {
                  self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                }

              }
      ).catch(function (error) {
        console.log(error);
      });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.costCenterId;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCostCenter";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
